import styled from "styled-components";

import Switch from "./Switch";

const Styled = styled.div`
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    font-family: var(--font-mono), monospace;
    gap: 2px;

    span {
        font-size: .8rem;
        color: #000;
        cursor: default;
        grid-column: span 2;
        padding: 4px 8px;
    }
`;

export default function LabeledSwitch(props) {
    const { disabled, label, onChange, options, value } = props;
    return (
        <Styled>
            <span>{ label }</span>
            <Switch
                disabled={ disabled }
                onChange={ onChange }
                options={ options }
                value={ value }
            />
        </Styled>
    );
}
